var mp = mp || {};


document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger);

    const panels = gsap.utils.toArray(".hero .panel");
    const total = panels.length;

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".hero",
            pin: true,
            scrub: 1,
            snap: {
                snapTo: 1 / (total - 1),
                duration: .6,
                ease: "power1.out"
            },
            end: () => "+=" + window.innerHeight * total,
            onToggle: (self) => {
                if (self.isActive) {
                    $(".tracks").addClass("have-offset");
                    $(".artists").addClass("have-offset");
                } else {
                    if (self.scroll() > 0) {
                        $(".tracks").removeClass("have-offset")
                    $(".artists").removeClass("have-offset");
                    }
                }
            },
        }
    });

    // initial state
    panels.forEach((panel, i) => {
        gsap.set(panel, {
            autoAlpha: i === 0 ? 1 : 0,
            yPercent: i === 0 ? 0 : -20,
        });
    });

    // crossfade timeline
    panels.forEach((panel, i) => {
        if (i === total - 1) return;

        tl.to(panels[i], { 
                autoAlpha: 0, yPercent: -20, duration: 1 
            }, i
        ).to(panels[i + 1], { 
            autoAlpha: 1, yPercent:0, duration: 1 
        }, i);
    });




    return;

    let currentIndex = 0;
    let animating;
    let swipePanels = gsap.utils.toArray(".hero__content .panel");

    // console.log(swipePanels);

    let intentObserver = ScrollTrigger.observe({
        type: "wheel,touch, scroll",
        onUp: (self) => {

        },
        onDown: (self) => {
            console.log(self);
        },
        tolerance: 2,
        preventDefault: true
    });

    intentObserver.disable();


    ScrollTrigger.create({
        trigger: ".hero",
        pin: true,
        start: "top top",
        markers: true,
        onEnter: () => {
            intentObserver.enable();
            // gotoPanel(currentIndex + 1, true);

            // console.log("enable", currentIndex);
            return;
        },
        onEnterBack: () => {
            intentObserver.enable();
            // gotoPanel(currentIndex - 1, false);
            // animating = false;

            // console.log("enable Back", currentIndex);
            return;
        },
    });

    function gotoPanel(index, isScrollingDown) {
    animating = true;
    // return to normal scroll if we're at the end or back up to the start
    if (
        (index === swipePanels.length && isScrollingDown) ||
        (index === -1 && !isScrollingDown)
    ) {
        intentObserver.disable();
        return;
    }

    let target = isScrollingDown ? swipePanels[currentIndex] : swipePanels[index];
    gsap.to(target, {
        yPercent: isScrollingDown ? -20 : 0,
        duration: 0.75,
        onComplete: () => (animating = false)
    });

    currentIndex = index;
    }

    // function gotoPanel(index, isScrollingDown) {
    //     // console.log(currentIndex);
    //     animating = true;

    //     if (
    //         (index > swipePanels.length && isScrollingDown) ||
    //         (index === -1 && !isScrollingDown)
    //     ) {
    //         intentObserver.disable();
    //         animating = false;

    //         // console.log("disable go to");
    //         return;
    //     }

    //     let target = isScrollingDown ? swipePanels[currentIndex] : swipePanels[index];
    //     gsap.timeline().to(target, {
    //         // duration: 0.5,
    //         onComplete: () => {
    //             swipePanels.forEach((panel) => {
    //                 panel.classList.remove("active");
    //             })

    //             target.classList.add("active");
    //         }
    //     }).to({}, {
    //         duration:1,
    //         onComplete: () => (
    //             animating = false
    //         )
    //     })

    //     currentIndex = index;
    //     // console.log(currentIndex);
    // }
});